import { render, staticRenderFns } from "./DeliveryTable.vue?vue&type=template&id=3a383bb3"
import script from "./DeliveryTable.vue?vue&type=script&lang=js"
export * from "./DeliveryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports